// pages/DeletionStatus.jsx
function DeletionStatus() {
  return (
    <div style={{ textAlign: "center", padding: "80px 24px", fontFamily: "sans-serif" }}>
      <h2>Data Deleted</h2>
      <p style={{ color: "#888", marginTop: "12px" }}>
        Your Memoir data has been successfully deleted.
      </p>
    </div>
  );
}

export default DeletionStatus;